const w = typeof window === 'undefined' ? {} : window;

const getEnvKey = key => (w.GLOBAL && w.GLOBAL.env[key]) || key;

export const LOGIN_PATH = process.env.GATSBY_LOGIN_PATH || getEnvKey('GATSBY_LOGIN_PATH');
export const ID_SERVICE_PATH = process.env.GATSBY_ID_SERVICE_PATH || getEnvKey('GATSBY_ID_SERVICE_PATH');
export const ERROR_REPORT_URL = process.env.GATSBY_ERROR_REPORT_URL || getEnvKey('GATSBY_ERROR_REPORT_URL');

const marketingSitePath = process.env.GATSBY_MARKETING_SITE_PATH || getEnvKey('GATSBY_MARKETING_SITE_PATH');

export const PATH = {
	forgotPassword: '/forgot-password',
	marketingSite: marketingSitePath,
	privacy: `${marketingSitePath}/legals/privacy-policy`,
	signIn: '/sign-in',
	terms: `${marketingSitePath}/legals/term-conditions`
};

export const NAME_MAX_LENGTH = 75;

export const INVITE_EMAIL = 'sales@mtribes.com';

export const TOKEN_STATES = {
	pending: 'Pending',
	expired: 'Expired'
};

export const PASSWORD_RESET_TOKEN_STATES = {
	valid: 'Valid',
	invalid: 'InValid'
};

export const PASSWORD_MESSAGES = {
	placeholder: 'Must be at least 8 characters',
	formatError: 'Must be at least 8 characters, contain a number, a lowercase and an uppercase letter.'
};

export const PASSWORD_REGEX = '(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}';
